<template>
  <template v-if="isConfigurable">
    <KeypadToggleSetting v-bind="{ ... $props, ... $attrs }" :style="cellStyle"
      :unit
      toggleTag="enabled"
      :toggleStateWhenDisabled="false"
      cellCaptionWhenDisabled="Disabled"
      keypadTitleWhenDisabled="Enter a value to enable the alarm"
      keypadTitleWhenEnabled=""
      disableButtonCaption="Disable alarm"
      :getDisableSubmitValues
    >
      <template v-if="props.tag.tripped.value">
        Tripped
      </template>
      <template #Buttons>
        <template v-if="props.tag.tripped.value">
          <Button severity="secondary" style="align-self: stretch;" @click="clearConfigurableAlarm()">
            Clear alarm
          </Button>
          <Button v-if="showingClearAllAlarms" severity="secondary" style="align-self: stretch;" @click="clearAllAlarms()">
            Clear all alarms
          </Button>
        </template>
      </template>
    </KeypadToggleSetting>
  </template>
  <template v-else>
    <TableCell v-bind="{ ... $props, ... $attrs }" :style="{ color: 'red' }">
      Tripped
      <template #BinSelectionInput>
        <slot name="BinSelectionInput"></slot>
      </template>
      <template #PopoverContentDesktop>
        <div style="display: flex; flex-direction: column; gap: 10px;">
          <Button severity="secondary" style="align-self: stretch;" @click="clearNonConfigurableAlarm()">
            Clear alarm
          </Button>
          <Button v-if="showingClearAllAlarms" severity="secondary" style="align-self: stretch;" @click="clearAllAlarms()">
            Clear all alarms
          </Button>
        </div>
      </template>
    </TableCell>
  </template>
  
</template>

<script setup>
import { computed } from "vue";

let props = defineProps([
  "tag",
  "unit",
  "popoverTitle",
  "toggleTag",
  "toggleStateWhenDisabled",
  "cellCaptionWhenDisabled",
  "keypadTitleWhenDisabled",
  "keypadTitleWhenEnabled",
  "disableButtonCaption"
]);

let cellStyle = computed(() => {
  let color = props.tag.tripped.value ? "red" : "";
  return { color };
});

function getDisableSubmitValues(cell) {
  return [
    { handle: props.tag.enabled.handle, value: false },
    { handle: props.tag.tripped.handle, value: false }
  ];
}

let isConfigurable = computed(() => {
  return "enabled" in props.tag && "value" in props.tag;
});

function clearConfigurableAlarm() {
  let session = props.tag.$session;
  props.tag.committed = false;
  session.changeValues([{ handle: props.tag.tripped.handle, value: false }], () => props.tag.committed = true);
}

function clearNonConfigurableAlarm() {
let session = props.tag.$session;
  props.tag.committed = false;
  session.changeValues([{ handle: props.tag.handle, value: false }], () => props.tag.committed = true);
}

let showingClearAllAlarms = computed(() => {
  let numAlarms = 0;
  store.sessions.forEach(session => {
    numAlarms += session.system.numAlarms.value
  });
  return numAlarms > 1;
});

function clearAllAlarms() {
  let tag = props.tag;
  let session = tag.$session;
  tag.committed = false;
  session.queueRequest("/cmd/clearAllAlarms", null, response => {
    session.updateTags(response.tags)
    tag.committed = true;
  });
}
</script>